import { request } from "../http";

export default {
    // 获取游客凭证
    getClientGuestToken(params) {
        return request('post', '/sd_smi/api/v1/Web_Guest/getClientGuestToken', params, 'json', { takeGuest: false });
    },

    // 发送验证码
    sendCode(params) {
        return request('post', '/sd_smi/api/v1/Sys_Public/sendSmsCode', params, 'json', { takeGuest: false ,useParams: true});
    },

    // 验证验证码
    checkCode(params) {
        return request('post', '/sd_smi/api/v1/Sys_Public/checkCode', params, 'json', { takeGuest: false });
    },

    // 注册接口
    reg(params,config={}) {
        // return request('post', '/sd_smi/api/v1/Web_Login/reg', params, 'json', { takeGuest: false });
        return request('post', '/blade-auth/oauth/token', params, 'json', { takeGuest: false ,useParams: true,...config});
    },

    // 登录接口
    login(params) {
        return request('post', '/sd_smi/api/v1/Web_Login/login', params, 'json', { takeGuest: false });
    },

    login2(params) {
      return request('post', '/blade-auth/oauth/token', params, 'json', { takeGuest: false,useParams: true });
    },

    refreshToken(params) {
      return request('post', '/blade-auth/oauth/token', params, 'json', { takeGuest: false,useParams: true });
    },


    // 忘记密码
    forgetPassword(params) {
        return request('post', '/sd_smi/api/v1/Sys_Public/forgetPassword', params, 'json');
    },

    // 第三方注册
    thirdLogin(params) {
        return request('post', '/sd_smi/api/v1/Web_Login/thirdLogin', params, 'json', { takeGuest: false });
    },

    // 第三方补全资料
    thirdFill(params) {
        return request('post', '/sd_smi/api/v1/Web_Login/thirdFill', params, 'json', { takeGuest: false });
    },

    // 检测电话号码是否已注册
    checkTelState(params) {
        return request('post', '/sd_smi/api/v1/Web_Login/checkTelState', params, 'json', { takeGuest: false });
    },
}



// WEBPACK FOOTER //
// ./src/request/apis/login.js